import { createTheme } from '@mui/material/styles';
import { defaultTheme } from './base';

let theme = defaultTheme();

export const nestingaleTheme = createTheme(theme, {});